// client/src/services/nonprofitApi.js
// Platform Admin → Nonprofits (server/routes/superAdminNonprofitRoutes.js).
// Rides the session cookie. Errors keep the response body so the tab can
// show the server's message (409 NOT_PENDING, 400 NOTE_REQUIRED, …).
// The tenant-side card (NonprofitDiscountCard) uses axios directly.

const BASE_URL = process.env.REACT_APP_BASE_URL?.replace(/\/$/, '') || '';
const base = '/api/super-admin/nonprofit';

async function call(method, url, body) {
  const res = await fetch(`${BASE_URL}${url}`, {
    method,
    credentials: 'include',
    headers: body !== undefined ? { 'Content-Type': 'application/json' } : undefined,
    body: body !== undefined ? JSON.stringify(body) : undefined,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(data.error || data.message || `${res.status}`);
    err.response = { status: res.status, data };
    throw err;
  }
  return data;
}

export const listApplications = ({ status = 'pending', q = '' } = {}) =>
  call('GET', `${base}/applications?status=${encodeURIComponent(status)}${q ? `&q=${encodeURIComponent(q)}` : ''}`);
export const getApplication = (id) => call('GET', `${base}/applications/${Number(id)}`);
export const revealRegistration = (id) => call('GET', `${base}/applications/${Number(id)}/registration`);
export const decide = (id, action, note) => call('POST', `${base}/applications/${Number(id)}/${action}`, { note: note || '' });
export const proofUrl = (id) => `${BASE_URL}${base}/applications/${Number(id)}/proof`;

export function errorText(err, fallback) {
  return (err && err.response && err.response.data && (err.response.data.error || err.response.data.message)) || fallback;
}
